import script from "./CategoriesRow.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoriesRow.vue?vue&type=script&setup=true&lang=js"

import "./CategoriesRow.vue?vue&type=style&index=0&id=344bbfc6&lang=css"

const __exports__ = script;

export default __exports__